import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const CalendarIcon: FC<SvgProps> = ({ fill = ColorEnum.GRAY_600, ...props }) => (
    <Svg fill="none" viewBox="0 0 16 16" {...props}>
        <Path
            d="M3.4496 14.8C3.00533 14.8 2.6304 14.6472 2.3248 14.3416C2.0192 14.036 1.8664 13.6611 1.8664 13.2168V4.1832C1.8664 3.73893 2.0192 3.364 2.3248 3.0584C2.6304 2.7528 3.00533 2.6 3.4496 2.6H3.9336V1.9336C3.9336 1.7336 4.00587 1.56133 4.1504 1.4168C4.2944 1.27227 4.472 1.2 4.6832 1.2C4.8832 1.2 5.05813 1.27493 5.208 1.4248C5.3584 1.57467 5.4336 1.74987 5.4336 1.9504V2.6H10.5664V1.9336C10.5664 1.7336 10.6387 1.56133 10.7832 1.4168C10.9277 1.27227 11.1056 1.2 11.3168 1.2C11.5168 1.2 11.6917 1.27493 11.8416 1.4248C11.9915 1.57467 12.0664 1.74987 12.0664 1.9504V2.6H12.5504C12.9947 2.6 13.3696 2.7528 13.6752 3.0584C13.9808 3.364 14.1336 3.73893 14.1336 4.1832V13.2168C14.1336 13.6611 13.9808 14.036 13.6752 14.3416C13.3696 14.6472 12.9947 14.8 12.5504 14.8H3.4496ZM3.4496 13.2168H12.5504V6.7H3.4496V13.2168ZM3.4496 5.3H12.5504V4.1832H3.4496V5.3Z"
            fill={fill}
        />
    </Svg>
)

export default CalendarIcon
